import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';


@Component({
  selector: 'page-poiedit',
  templateUrl: 'poiedit.html',
})
export class PoieditPage {
  poiData:any
  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.poiData = navParams.get('data')
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad PoieditPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/poisettings/poiedit.ts